import React, { Component } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { reports } from "../../../components/Report.js";
export default class StockChecks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manage_type: "",
      modal_create: false,
      modal_update: false,
      visible: false,

      filter_search: "",
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_category_id: "",
      filter_diff: "",

      data: [],
      count: 10,
      data_product: [],
      data_user: [],
      data_warehouse: [],
      data_category: [],

      data_check: [],

      tab: "check-list",

      id: "",
      uid: "",
      return_code: "",

      // สินค้า
      type: "",
      name: "",
      date: "",
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      warehouse_name: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      category_id: "",
    };

        this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1); 
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { visible } = this.state;
    if (window.pageYOffset > 300 && !visible) {
      this.setState({ visible: true });
    } else if (window.pageYOffset <= 300 && visible) {
      this.setState({ visible: false });
    }
  };

scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  Get = async (page) => {
    const { filter_status, filter_search, filter_start_date, filter_end_date } =
      this.state;
    let data, count, data_user, data_warehouse, data_product, data_category;
    loading(true);
    let [
      result,
      result_user,
      result_warehouse,
      result_product,
      result_category,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: page,
        data_search: filter_search,
        type: "เช็คสต็อก",
        status_code: filter_status,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
      }),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data
        ?.filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          category_name: e.products?.category?.name || "",
          serial_number: e.serial_number ? e.serial_number.toString() : "",
          balance: e.balance,
        }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    this.setState({
      data,
      count,
      data_user,
      data_warehouse,
      data_product,
      data_category,
    });
    loading(false);
  };

  GetByID = async (uid) => {
    loading(true);
    const { filter_diff } = this.state;
    let data_product = [];
    let [
      result,
      result_product,
    ] = await Promise.all([
      GET("admin/stock-activities/list", { uid }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
    ]);
    if (result_product?.status) {
      data_product = result_product.data
        ?.filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          category_name: e.products?.category?.name || "",
          serial_number: e.serial_number ? e.serial_number.toString() : "",
          balance: e.balance,
        }));
    }
    this.setState({
      ...result.data,
      uid: uid,
      supplier_id: result.data?.supplier?.uid,
      warehouse_id: result.data?.warehouse?.uid,
      warehouse_name: result.data?.warehouse?.name,
      destination_warehouse_id: result.data?.destination_warehouse?.uid,
      user_id: result.data?.user?.uid,
      transaction_list: result.data?.transaction_list?.map((e) => ({
        ...e,
        product_id:
          data_product.find((p) => p.product_code === e.product_code)?.value ||
          "",
        category_id: data_product.find(
          (p) =>
            p.warehouse_id === result.data?.warehouse?.uid &&
            p.product_code === e.product_code
        )?.category_id,
        serial_number: data_product.find(
          (p) =>
            p.warehouse_id === result.data?.warehouse?.uid &&
            p.product_code === e.product_code
        )?.serial_number,
      })).filter(item => {
        let diff = ((data_product.find((e) => e.warehouse_id === result.data?.warehouse?.uid && e.product_code === item.product_code)?.balance || 0) - item.qty);
        if(filter_diff === "น้อยกว่า 0"){
          return diff < 0;
        }else if(filter_diff === "เท่ากับ 0"){
          return diff === 0;
        }else if(filter_diff === "มากกว่า 0"){
          return diff > 0;
        }
        return true;
      }).filter(e=>e.type !== "ขายหน้าร้าน"),
      data_product
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const {
      modal_create,
      uid,
      category_id,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
    } = this.state;
    if (!name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อการตรวจนับ");
      return;
    } else if (!activity_type.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการตรวจนับ");
      return;
    } else if (!warehouse_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    } else if (!start_date.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่เริ่มต้น");
      return;
    } else if (!end_date.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่สิ้นสุด");
      return;
    } else if (!user_id.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกผู้รับผิดชอบ");
      return;
    }

    if (activity_type === "ตรวจนับตามหมวดหมู่" && !category_id) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกหมวดหมู่");
      return;
    }

    loading(true);
    let body = {
      type: "เช็คสต็อก",
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      category_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status: modal_create ? "กำลังดำเนินการ" : status,
      remark,
      transaction_list: transaction_list.map(e=>({...e, serial_number: e.serial_number ? e.serial_number.split(","):[]})),
    };

    let result = !uid
      ? await POST("admin/stock-activities/create", body)
      : await PUT("admin/stock-activities/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  UpdateStock = async () => {
    const { uid, transaction_list, warehouse_id, user_id, name } = this.state;
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "ยืนยันการบันทึกข้อมูลและปรับสต็อกหรือไม่?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/stock-activities/update/" + uid, {
        transaction_list: transaction_list,
        status: "เสร็จสิ้น",
      });
      if (result?.status) {
        result = await POST("admin/stock-activities/create", {
          name: name,
          type: "ปรับจำนวน",
          date: format_date(new Date(), "yyyy-mm-dd", "en"),
          start_date: format_date(new Date(), "yyyy-mm-dd", "en"),
          end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
          count_item: transaction_list.length,
          activity_type: "ปรับจำนวน",
          warehouse_id: warehouse_id,
          user_id: user_id,
          cause: "ตรวจนับสต็อก",
          status: "เสร็จสิ้น",
          transaction_list,
        });
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "แจ้งเตือน",
            result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
          );
        }
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยืนยันข้อมูล",
        "ยืนยันการยกเลิกรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/stock-activities/update/" + id, {
        status: "ยกเลิก",
      });
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };

  getFilteredTransactionList = () => {
    const {
      transaction_list,
      filter_search,
      filter_category_id,
      warehouse_id,
      data_product,
    } = this.state;
    return (transaction_list || []).filter((item) => {
      const productKey = `${item.product_code || ""}${item.product_name || ""}`;
      if (filter_search && !productKey.includes(filter_search)) {
        return false;
      }
      if (filter_category_id) {
        const categoryId = data_product.find(
          (p) =>
            p.warehouse_id === warehouse_id &&
            p.product_code === item.product_code
        )?.category_id;
        if (categoryId !== filter_category_id) {
          return false;
        }
      }
      return true;
    });
  };

  prepareTableForExport = (table) => {
    const clone = table.cloneNode(true);
    clone.querySelectorAll("input").forEach((input) => {
      const td = input.closest("td");
      if (td) {
        td.textContent = input.value ?? "";
      }
    });
    clone.querySelectorAll("button").forEach((btn) => btn.remove());
    return clone;
  };

  ExportExcel = () => {
    const table = this.tableRef.current;
    if (!table) {
      alert("", "warning", "แจ้งเตือน", "ไม่พบข้อมูลตาราง");
      return;
    }
    const rows = table.querySelectorAll("tbody tr");
    if (!rows.length) {
      alert("", "warning", "แจ้งเตือน", "ไม่มีรายการสินค้าให้ Export");
      return;
    }
    downloadExcel(
      {
        fileName: "รายการเช็คสต็อก.xls",
        sheet: "รายการเช็คสต็อก",
      },
      this.prepareTableForExport(table)
    );
  };

  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return;

    const rows = Array.from(
      this.prepareTableForExport(table).querySelectorAll("tbody tr")
    );
    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    const alignments = [
      "center",
      "left",
      "left",
      "left",
      "right",
      "right",
      "left",
      "right",
      "center",
    ];

    const pdfHeader = (text) => ({
      text,
      alignment: "center",
      bold: true,
      noWrap: true,
    });

    const obj = {
      table: {
        headerRows: 1,
        widths: [24, "*", 52, 68, 68, 68, 32, 78, 52],
        body: [
          [
            pdfHeader("ลำดับ"),
            pdfHeader("รหัสสินค้า/ชื่อสินค้า"),
            pdfHeader("หมวดหมู่"),
            pdfHeader("คลังสินค้า"),
            pdfHeader("จำนวนในระบบ"),
            pdfHeader("จำนวนที่นับได้"),
            pdfHeader("หน่วย"),
            pdfHeader("ความคลาดเคลื่อน"),
            pdfHeader("Serial No."),
          ],
          ...data_list.map((item, index) => {
            let border = [1, 0, 1, 0];
            const color = "#ffffff";
            if (index === data_list.length - 1) {
              border = [1, 0, 1, 1];
            }
            return item.map((cell, colIndex) => ({
              text: cell,
              alignment: alignments[colIndex] || "left",
              fillColor: color,
              border:
                colIndex === 0
                  ? [1, border[1], border[2], border[3]]
                  : colIndex === item.length - 1
                    ? [border[0], border[1], 1, border[3]]
                    : border,
            }));
          }),
        ],
      },
    };
    reports("รายการเช็คสต็อก", obj, 12, "landscape");
  };

  render() {
    const {
      manage_type,
      modal_create,
      modal_update,
      data_product,
      data_user,
      data_warehouse,
      data_category,
      filter_category_id,
      filter_search,
      filter_status,
      filter_start_date,
      filter_end_date,
      filter_diff,
      data,
      count,
      data_check,
      tab,
      return_code,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      warehouse_name,
      uid,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      category_id,
      visible
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between flex-wrap mb-3">
              <h4 className="fw-bold mb-3 me-3">ตรวจนับสต็อกสินค้า</h4>
              {tab === "check-stock" && (
                <button
                  className="btn btn-outline-dark"
                  onClick={async () => {
                    this.setState({ tab: "check-list" });
                  }}
                >
                  ย้อนกลับ
                </button>
              )}
            </div>
            {tab === "check-list" && (
              <div>
                <div className="d-flex align-items-center flex-wrap">
                  <input
                    type="text"
                    className="form-control wpx-200 me-2 mb-2"
                    placeholder="ค้นหาการตรวจนับ..."
                    onChange={(e) => {
                      this.setState({ filter_search: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Get(1);
                      }
                    }}
                    value={filter_search}
                  />
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_status: e.target.value });
                    }}
                    value={filter_status}
                  >
                    <option value="">สถานะ</option>
                    <option value="กำลังดำเนินการ">กำลังดำเนินการ</option>
                    <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                    <option value="ยกเลิก">ยกเลิก</option>
                  </select>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_start_date: e.target.value });
                    }}
                    value={filter_start_date}
                  />
                  <span className="px-2 me-2 mb-2">ถึง</span>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_end_date: e.target.value });
                    }}
                    value={filter_end_date}
                  />
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.Get(1);
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.setState({
                          filter_search: "",
                          filter_status: "",
                          filter_start_date: "",
                          filter_end_date: "",
                        });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                  <button
                    className="btn btn-dark px-3 ms-auto mb-2 stock-checks.create"
                    onClick={async () => {
                      this.setState({
                        id: "",
                        uid: "",
                        type: "",
                        name: "",
                        date: "",
                        start_date: "",
                        end_date: "",
                        count_item: "",
                        ref_number: "",
                        activity_type: "",
                        customer_id: "",
                        supplier_id: "",
                        warehouse_id: "",
                        user_id: "",
                        amount: "",
                        discount: "",
                        vat: "",
                        amount_net: "",
                        cause: "",
                        status: "",
                        remark: "",
                        transaction_list: [],
                        modal_create: true,
                      });
                    }}
                  >
                    สร้างการตรวจนับ
                  </button>
                </div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">เลขที่เอกสาร</td>
                        <td className="text-nowrap">ชื่อการตรวจนับ</td>
                        <td className="text-nowrap">วันที่สร้าง</td>
                        <td className="text-nowrap">วันที่เริ่มต้น</td>
                        <td className="text-nowrap">วันที่สิ้นสุด</td>
                        <td className="text-nowrap">คลังสินค้า</td>
                        <td className="text-nowrap">สถานะ</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">
                            {item.document_no || "-"}
                          </td>
                          <td className="text-nowrap">{item.name || "-"}</td>
                          <td className="text-nowrap">
                            {item.created_at
                              ? format_date(item.created_at)
                              : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.start_date
                              ? format_date(item.start_date)
                              : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.end_date ? format_date(item.end_date) : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.warehouse?.name || "-"}
                          </td>
                          <td className="text-nowrap">{item.status || "-"}</td>
                          <td className="text-center align-middle wpx-100">
                            <div className="d-flex">
                               {item.status === "ยกเลิก" && (
                                <BtnIcon
                                  type="view"
                                  onClick={async () => {
                                    await this.GetByID(item.uid);
                                    this.setState({ tab: "check-stock",manage_type:"view" });
                                  }}
                                />
                              )}
                              {item.status !== "ยกเลิก" && (
                                <BtnIcon
                                  className="banks.update"
                                  type="update"
                                  onClick={async () => {
                                    await this.GetByID(item.uid);
                                    this.setState({ tab: "check-stock", manage_type: "" });
                                  }}
                                />
                              )}
                              {item.status === "กำลังดำเนินการ" && (
                                <BtnIcon
                                  className="banks.delete"
                                  type="delete"
                                  onClick={() => {
                                    this.Delete(item.uid);
                                  }}
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                  <Pagination
                    className="mb-3"
                    count={Math.ceil(count / 10) || 1}
                    showFirstButton
                    showLastButton
                    onChange={(_, page) => this.Get(page)}
                  />
                </div>
              </div>
            )}
            {tab === "check-stock" && (
              <div className="position-relative">
                <div className="row mb-3">
                  <div className="col-12 mb-2">
                    <div className="mb-1">ชื่อ{required}</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ชื่อ..."
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                      value={name}
                      disabled={status !== "กำลังดำเนินการ" || manage_type === "view"}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-3 mb-2">
                    <div className="mb-1">คลัง{required}</div>
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้า..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ warehouse_id: e });
                      }}
                      value={warehouse_id}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-3 mb-2">
                    <div className="mb-1">ผู้ตรวจนับ{required}</div>
                    <Select
                      className="form-control"
                      placeholder="ผู้ตรวจนับ..."
                      options={data_user}
                      onChange={(e) => {
                        this.setState({ user_id: e });
                      }}
                      value={user_id}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-3 mb-2">
                    <div className="mb-1">วันที่เริ่มต้น{required}</div>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="วันที่เริ่มต้น..."
                      onChange={(e) => {
                        this.setState({ start_date: e.target.value });
                      }}
                      value={start_date}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-3 mb-2">
                    <div className="mb-1">วันที่สิ้นสุด{required}</div>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="วันที่สิ้นสุด..."
                      onChange={(e) => {
                        this.setState({ end_date: e.target.value });
                      }}
                      value={end_date}
                      disabled
                    />
                  </div>
                </div>
                <hr />
                <div className="mb-5">
                  <div className="d-flex align-items-center flex-wrap">
                    <Select
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="หมวดหมู่..."
                      options={data_category.filter(
                        (e) => !warehouse_id || e.warehouse_id === warehouse_id
                      )}
                      onChange={(e) => {
                        this.setState({ filter_category_id: e });
                      }}
                      value={filter_category_id}
                    >
                      <option value=""></option>
                    </Select>
                    <input
                      type="text"
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ค้นหา..."
                      onChange={(e) => {
                        this.setState({ filter_search: e.target.value });
                      }}
                      value={filter_search}
                    />
                    <select
                      type="text"
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ความคลาดเคลื่อน..."
                      onChange={(e) => {
                        this.setState({ filter_diff: e.target.value });
                      }}
                      value={filter_diff}
                    >
                      <option value="">ความคลาดเคลื่อน...</option>
                      <option value="น้อยกว่า 0">น้อยกว่า 0</option>
                      <option value="เท่ากับ 0">เท่ากับ 0</option>
                      <option value="มากกว่า 0">มากกว่า 0</option>
                    </select>

                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.GetByID(uid);
                        }}
                      >
                        ค้นหา
                      </button>
                      <button
                        className="btn btn-outline-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.setState({
                            filter_search: "",
                            filter_category_id: "",
                            filter_diff: ""
                          });
                          setTimeout(() => {
                            this.GetByID(uid);
                          }, 100);
                        }}
                      >
                        ล้างค่า
                      </button>
                    </div>
              <div className="ms-auto">
                <button className="btn btn-dark px-3 mb-2 me-2" onClick={() => {this.GetByID(uid)}}>รีโหลด</button>
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <button
                  className="btn btn-warning px-3 mb-2"
                  onClick={() => this.ExportExcel()}
                >
                  Excel
                </button>
              </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table rounded-3 overflow-hidden table-hover" ref={this.tableRef}>
                      <thead>
                        <tr>
                          <th className="text-nowrap">ลำดับ</th>
                          <th className="text-nowrap">รหัสสินค้า/ชื่อสินค้า</th>
                          <th className="text-nowrap">หมวดหมู่</th>
                          <th className="text-nowrap">คลังสินค้า</th>
                          <th className="text-nowrap text-center">
                            จำนวนในระบบ
                          </th>
                          <th className="text-nowrap text-center">
                            จำนวนที่นับได้
                          </th>
                          <th className="text-nowrap">หน่วย</th>
                          <th className="text-nowrap text-center">
                            ความคลาดเคลื่อน
                          </th>
                          <th className="text-nowrap text-center">
                            Serial No.
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.getFilteredTransactionList().map(
                          (item, displayIndex) => {
                            const index = transaction_list.indexOf(item);
                            return (
                              <tr key={`${item.product_code}-${displayIndex}`}>
                                <td className="text-nowrap">{displayIndex + 1}</td>
                                <td className="text-nowrap">
                                  {item.product_code} {item.product_name}
                                </td>
                                <td className="text-nowrap">
                                  {data_product.find(
                                    (e) =>
                                      e.warehouse_id === warehouse_id &&
                                      e.product_code === item.product_code
                                  )?.category_name || 0}
                                </td>
                                <td className="text-nowrap">
                                  {warehouse_name || "-"}
                                </td>
                                <td className="text-nowrap text-center">
                                  {data_product.find(
                                    (e) =>
                                      e.warehouse_id === warehouse_id &&
                                      e.product_code === item.product_code
                                  )?.balance || 0}
                                </td>
                                <td className="text-nowrap text-center">
                                  {status === "เสร็จสิ้น" || manage_type === "view" ? (
                                    item.qty
                                  ) : (
                                    <div className="d-flex">

                                  <div style={{width:0,opacity:0}}>{item.qty}</div>
                                      <button
                                        className="btn btn-primary wpx-30"
                                        onClick={() => {
                                          if (item.qty > 0) {
                                            transaction_list[index].qty =
                                              item.qty - 1;
                                            this.setState({ transaction_list });
                                          }
                                        }}
                                      >
                                        -
                                      </button>
                                      <input
                                        type="text"
                                        className="form-control wpx-60 mx-1 text-center"
                                        onChange={(e) => {
                                          if (!float(e.target.value)) return;
                                          transaction_list[index].qty = Number(
                                            e.target.value
                                          );
                                          this.setState({ transaction_list });
                                        }}
                                        value={item.qty}
                                      />
                                      <button
                                        className="btn btn-primary wpx-30"
                                        onClick={() => {
                                          transaction_list[index].qty += 1;
                                          this.setState({ transaction_list });
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </td>
                                <td className="text-nowrap">
                                  {item.unit_name || "-"}
                                </td>
                                <td
                                  className={
                                    ((data_product.find(
                                      (e) =>
                                        e.warehouse_id === warehouse_id &&
                                        e.product_code === item.product_code
                                    )?.balance || 0) -
                                      item.qty !==
                                    0
                                      ? "text-danger"
                                      : "") + " text-nowrap text-center "
                                  }
                                >
                                  {(data_product.find(
                                    (e) =>
                                      e.warehouse_id === warehouse_id &&
                                      e.product_code === item.product_code
                                  )?.balance || 0) - item.qty}
                                </td>
                                <td className="text-nowrap">
<div className="d-flex">
                                  <div style={{width:0,opacity:0}}>{item.serial_number}</div>
                                  {status === "เสร็จสิ้น" || manage_type === "view" ? item.serial_number:(
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => {transaction_list[index].serial_number = e.target.value;
                                          this.setState({ transaction_list });}}
                                          value={item.serial_number}
                                  />
                                  )}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!["เสร็จสิ้น","ยกเลิก"].includes(status) && (
                  <div className="w-100 bg-white py-2 px-3 border-0 d-flex justify-content-end position-fixed" style={{bottom:0,left:0}}>
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-5 me-1"
                        onClick={() => {
                          this.UpdateStock();
                        }}
                      >
                        บันทึกและปรับสต็อก
                      </button>
                      <button
                        className="btn btn-primary px-5 me-1"
                        onClick={() => {
                          this.CreateUpdate();
                        }}
                      >
                        บันทึก
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {visible && (
            <button
              className="position-fixed btn btn-primary"
              onClick={() => {
                this.scrollToTop();
              }}
              style={{ top: 30, right: 30 }}
            >
              กดเพื่อไปยังด้านบน
            </button>
          )}
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}
              การตรวจนับใหม่
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ชื่อการตรวจนับ{required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อการตรวจนับ..."
                onChange={(e) => {
                  this.setState({ name: e.target.value });
                }}
                value={name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ประเภทการตรวจนับ{required}</div>
              <Select
                className="form-control"
                placeholder="ประเภทการตรวจนับ..."
                options={["ตรวจนับตามหมวดหมู่", "ตรวจนับแบบรวม"].map(
                  (item) => ({ value: item, label: item })
                )}
                onChange={(e) => {
                  this.setState({ activity_type: e, category_id: "" });
                }}
                value={activity_type}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">คลังสินค้า{required}</div>
              <Select
                className="form-control"
                placeholder="คลังสินค้า..."
                options={data_warehouse}
                onChange={(e) => {
                  this.setState({ warehouse_id: e });
                }}
                value={warehouse_id}
              />
            </div>
            {activity_type === "ตรวจนับตามหมวดหมู่" && (
              <div className="d-flex mb-3">
                <div className="wpx-150 mt-2">หมวดหมู่{required}</div>
                <Select
                  className="form-control"
                  placeholder="หมวดหมู่..."
                  options={data_category?.filter(
                    (e) => e.warehouse_id === warehouse_id
                  )}
                  onChange={(e) => {
                    this.setState({ category_id: e });
                  }}
                  value={category_id}
                />
              </div>
            )}
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">วันที่เริ่มต้น{required}</div>
              <input
                type="date"
                className="form-control"
                placeholder="วันที่เริ่มต้น..."
                onChange={(e) => {
                  this.setState({ start_date: e.target.value });
                }}
                value={start_date}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">วันที่สิ้นสุด{required}</div>
              <input
                type="date"
                className="form-control"
                placeholder="วันที่สิ้นสุด..."
                onChange={(e) => {
                  this.setState({ end_date: e.target.value });
                }}
                value={end_date}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">ผู้รับผิดชอบ{required}</div>
              <Select
                className="form-control"
                placeholder="ผู้รับผิดชอบ..."
                options={data_user}
                onChange={(e) => {
                  this.setState({ user_id: e });
                }}
                value={user_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2">หมายเหตุ</div>
              <textarea
                className="form-control"
                placeholder="หมายเหตุ..."
                rows={5}
                onChange={(e) => {
                  this.setState({ remark: e.target.value });
                }}
                value={remark}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
